import './ instrument';
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { RootRouter } from './navigation/root.router';
import config from './config';
import appConfig from '@project/config';
import ReactGA from 'react-ga4';
import { GoogleReCaptchaProvider } from '@google-recaptcha/react';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const App = () => {
  ReactGA.initialize(appConfig.gaMeasurementId);

  return (
    <GoogleReCaptchaProvider siteKey={config.recaptchaSiteKey} type={'v2-checkbox'}>
      <QueryClientProvider client={queryClient}>
        <Toaster position="top-center" />
        <BrowserRouter>
          <RootRouter />
        </BrowserRouter>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </GoogleReCaptchaProvider>
  );
};

export default App;
